//flagging as unused but it is on line 30
// eslint-disable-next-line
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Table } from "../../../components/Table";
import { UserPermissions } from "../../../enums";
import { Api } from "../../../services/api";
import { useAppSelector } from "../../../store/hooks";
import { getColumns, defaultSliderFilters } from "./columnData";
import { Container } from "../Admin.styles";

export const Teams = () => {
  const history = useHistory();
  const userPermissions = useAppSelector(state => state.auth.user.permissions);
  const token = useAppSelector(state => state.auth.token);
  const [tableData, setTableData] = useState<Array<any>>([]);
  const { data, isLoading } = Api.teams.getQuery();

  useEffect(() => {
    if (data) setTableData(data?.data);
  }, [data]);

  let handleAddTeam;
  if (userPermissions.includes(UserPermissions.TeamAddTeam)) {
    handleAddTeam = () => {
      const currentLocation = history.location;
      currentLocation.pathname = `${currentLocation.pathname}/add`;
      history.push(currentLocation);
    };
  }

  return (
    <>
      <Container>
        <Table
          searchable
          title="Teams"
          tableType="Teams"
          isLoading={isLoading}
          defaultRows={20}
          columns={getColumns(token)}
          rowsPerPage={[10, 20, 35, 50]}
          data={tableData}
          sliderFilters={defaultSliderFilters}
          handleAddButton={handleAddTeam}
        />
      </Container>
    </>
  );
};
